<template>
  <component
    :is="layout"
    v-if="!isLoading"
  >
    <RouterView />

    <TheGlobalPreloader />
  </component>
</template>

<script lang="ts" setup>
import TheGlobalPreloader from '@components/TheGlobalPreloader.vue'
import { storeToRefs } from 'pinia'
import { computed, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useUpdateVuetifyTheme } from './composables/useUpdateVuetifyTheme'
import EmptyLayout from './layouts/EmptyLayout.vue'
import GuestLayout from './layouts/GuestLayout.vue'
import MainLayout from './layouts/MainLayout.vue'
import { useMenuStore } from './stores/menuStore'
import { useSettingsStore } from './stores/settingsStore'

const route = useRoute()
const router = useRouter()
const settingsStore = useSettingsStore()
const menuStore = useMenuStore()

const { isLoading: settingsLoading } = storeToRefs(settingsStore)

const isRouterReady = ref(false)
const isLoading = computed(() => settingsLoading.value || !isRouterReady.value)

onMounted(async () => {
  await router.isReady()
  isRouterReady.value = true
  menuStore.setActiveItemFromRoute(route)
})

const layout = computed(() => {
  const current = route.meta.layout || 'GuestLayout'
  switch (current) {
    case 'EmptyLayout':
      return EmptyLayout
    case 'GuestLayout':
      return GuestLayout
    case 'MainLayout':
      return MainLayout
    default:
      return GuestLayout
  }
})

useUpdateVuetifyTheme()
</script>
